module.exports = __webpack_public_path__ + "img/image2.4b1c0ffb.png";